import React from 'react';
import { StyleSheet } from 'react-native';
import { useThemeContext } from '../../hook/useThemeManager';
import { AppBar, Toolbar, Box, Typography, Icon, Link } from '@mui/material';
import { ColorScheme, theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { ThspianFullLogo } from '../ThspianLogo/ThspianFullLogo';
import { ROUTES } from '../../types/global/routes.types';
import { en_config } from '../../config';
import { Situation } from '../Situation/Situation';
import ArrowRightIcon from '../CustomSVGIcons/ArrowRightIcon';

const EsLoginHeader = () => {
    const { themeStyle } = useThemeContext();
    const styles = dynamicStyles(themeStyle);

    return (
        <Box style={styles.container}>
            <AppBar position="static" style={styles.bg}>
                <Toolbar
                    sx={{
                        paddingInline: { xs: '16px', md: '24px', lg: '40px' },
                        paddingTop: { xs: '32px', sm: '40px' },
                        paddingBottom: { xs: '32px', sm: '40px' },
                    }}>
                    <Box display="flex" flexGrow={1}>
                        <Link
                            href={ROUTES.ESDISCOVERY}
                            sx={{
                                width: { xs: '125px', sm: '170px' },
                                height: { xs: '18px', sm: '24px' },
                                alignItems: 'center',
                                display: 'flex',
                                justifyContent: 'center',
                            }}>
                            <ThspianFullLogo width={'120px'} height={'40px'} fill={theme[themeStyle].logo_color} />
                            {en_config.IS_BETA && <Situation label="beta" />}
                        </Link>
                    </Box>
                    <Link
                        href="/discovery"
                        sx={{
                            '&:hover': { cursor: 'pointer' },
                            textDecoration: 'none',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                        <Typography style={styles.text} sx={{ fontSize: { xs: '14px', sm: '16px' } }}>
                            Go Home
                        </Typography>
                        <Icon
                            sx={{
                                width: { xs: '18px', sm: '24px' },
                                height: { xs: '18px', sm: '24px' },
                                alignItems: 'center',
                                display: 'flex',
                                justifyContent: 'center',
                            }}>
                            <ArrowRightIcon fill={theme[themeStyle].logo_color} />
                        </Icon>
                    </Link>
                </Toolbar>
            </AppBar>
        </Box>
    );
};
const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        container: {
            width: '100vw',
            position: 'absolute',
            top: 0,
        },
        bg: {
            backgroundColor: theme[colorScheme].transparent,
            boxShadow: 'none',
        },
        text: {
            color: theme[colorScheme].logo_color,
            marginRight: 8,
            fontFamily: FONT_ENUM.MAIN_MEDIUM,
        },
    });

export { EsLoginHeader };
